import { useCallback, useEffect, useState } from "react";
import { useStateContext } from "../../contexts/ContextProvider";
import profileImg from "../../assets/images/profile.png";
import Editor from "react-simple-wysiwyg";
import LeaveHistoryService from "../../services/leaveHistory.service";
import AuthService from "../../services/auth.service";
import moment from "moment";
import { is } from "date-fns/locale";

const ApproveRequest = ({
  leaveDays,
  selectedRowData,
  setSuccess,
  fetchData,
  setApproveModal,
  setHeading,
}) => {
  const { approveModal, getNameInitials } = useStateContext();

  const [html, setHtml] = useState("");

  const user = AuthService.getCurrentUser();

  const [approvedDayslist, setApprovedDayslist] = useState([]);

  const [leaveInfo, setLeaveInfo] = useState({});

  const checkLeaveInfo = useCallback(() => {
    const payload = {
      empId: selectedRowData.emp_id,
    };
    // console.log("Payload for Leave Info:", payload);
    if (payload.empId) {
      LeaveHistoryService.getEmpInfo(payload)
        .then((resp) => {
          if (resp.data) {
            // console.log("Leave Info:", resp.data);
            setLeaveInfo(resp.data[0]);
          }
        })
        .catch((e) => console.log(e));
    } else {
      setLeaveInfo({});
    }
  }, [selectedRowData]);

  useEffect(() => {
    checkLeaveInfo();
  }, [checkLeaveInfo]);

  const fetchEmpLeaveDays = useCallback(() => {
    const payload = {
      reqid: selectedRowData.rid,
      empid: selectedRowData.emp_id,
    };
    
    if (approveModal) {
      LeaveHistoryService.getEmpLeaveDayslist(payload)
        .then((resp) => {
          // console.log("Emp Leave Days List Response:", resp.data);
          if (selectedRowData.rmActionsts === "1") {
            const data = resp.data.map((item) => ({
              ...item,
              ispaid: item.ispaidval,
            }));
            setApprovedDayslist(data);
          } else {
            const data = resp.data.map((item) => ({
            ...item,
            ispaid: item.ispaidval,
            isApproved: "1",
          }));
          setApprovedDayslist(data);
          }
          
        })
        .catch((e) => console.log(e));
    }

    // if (
    //   Object.values(payload).filter((value) => value !== undefined).length > 0
    // ) {
    //   LeaveHistoryService.getEmpLeaveDays(payload)
    //     .then((resp) => {
    //       if (resp.data.length > 0 && Array.isArray(leaveDays)) {
    //         // Merge API data with leaveDays using dateval
    //         const merged = leaveDays.map((ld) => {
    //           const apiItem = resp.data.find((api) => api.date === ld.dateval);
    //           return apiItem ? { ...ld, ...apiItem, } : { ...ld };
    //         });
    //         const filteredMerged = merged.map((item) => ({
    //           ...item,
    //           ispaid: item.isApproved
    //         }));
    //         // console.log("merged", filteredMerged, merged, resp.data);
    //         setApprovedDayslist(filteredMerged);
    //       } else if (resp.data) {
    //         // If API didn't return per-day info, derive it from leaveDays.
    //         // Mark `ispaid` = "1" up to the employee's quarterly paid balance,
    //         // then mark subsequent leave days as unpaid ("0"). Half-days count as 0.5.
    //         const quarterlyBalance = Number(leaveInfo.queterlyBalanceLeave) || 0;
    //         let remainingPaid = quarterlyBalance;
    //         setApprovedDayslist(
    //           Array.isArray(leaveDays)
    //             ? leaveDays.map((item) => {
    //                 const dayValue = item.workday === "0.5" ? 0.5 : 1;
    //                 let ispaid = "1";
    //                 if (item.daytype === "3") {
    //                   // If any remaining paid balance exists, mark this day as paid.
    //                   // This treats partial balances (e.g. 2.5) as covering the next day
    //                   // so 2.5 => three days will be flagged paid.
    //                   if (remainingPaid > 0) {
    //                     ispaid = "1";
    //                     remainingPaid -= dayValue;
    //                   } else {
    //                     ispaid = "0";
    //                   }
    //                 } else {
    //                   // For non-leave day types (holidays), keep paid flag as "1"
    //                   ispaid = "1";
    //                 }

    //                 return {
    //                   ...item,
    //                   date: moment(item.dateval, "DD-MM-YYYY").format(
    //                     "YYYY-MM-DD"
    //                   ),
    //                   ishaifDay: item.workday === "0.5" ? "1" : "0",
    //                   ispaid,
    //                   isGoodWill: "0",
    //                   isApproved:
    //                     item.daytype === "3" &&
    //                     selectedRowData.leavedays >=
    //                       leaveInfo.queterlyBalanceLeave
    //                       ? "1"
    //                       : "0",
    //                 };
    //               })
    //             : []
    //         );
    //       }
    //     })
    //     .catch((e) => console.log(e));
    // }

  }, [approveModal]);

  useEffect(() => {
    fetchEmpLeaveDays();
  }, [fetchEmpLeaveDays]);

  const setIsPaid = (e, date) => {
    const checked = e.target.checked;
    setApprovedDayslist((prev) =>
      prev.map((item) =>
        item.lDate === date ? { ...item, ispaid: checked ? "1" : "0", isApproved : checked || item.isGoodWill === "1" ? "1" : "0" } : item,
      ),
    );
  };

  const setIsGoodwill = (e, date) => {
    const checked = e.target.checked;
    setApprovedDayslist((prev) =>
      prev.map((item) =>
        item.lDate === date
          ? { ...item, isGoodWill: checked ? "1" : "0", ispaid : checked || item.ispaid === "1" ? "1" : "0", isApproved : checked || item.ispaid === "1" ? "1" : "0" }
          : item
      )
    );
  };

  

  const setIsApproved = (date) => {
    setApprovedDayslist((prev) =>
      prev.map((item) =>
        item.lDate === date
          ? { ...item, isApproved: item.isApproved === "1" ? "0" : "1", ispaid : item.isApproved === "1" ? "0" : item.ispaid, 
            isGoodWill : item.isApproved === "1" ? "0" : item.isGoodWill }
          : item
      )
    );
  };

  // console.log("approvedDayslist", approvedDayslist);

  const onChange = (e) => {
    setHtml(e.target.value);
  };

  // Calculate counts
  const isGoodWillCount = approvedDayslist
    .filter((item) => item.isGoodWill === "1")
    .reduce((sum, item) => sum + (item.ishalfday === "1" ? 0.5 : 1), 0);
  const isApprovedCount = approvedDayslist
    .filter((item) => item.isApproved === "1" && item.datetype === "Weekday")
    .reduce((sum, item) => sum + (item.ishalfday === "1" ? 0.5 : 1), 0);

  const approveLeaveRequest = () => {
    // Ensure at least one day is approved before proceeding
    const hasApprovedDay = approvedDayslist.some(
      (item) => item.datetype === "Weekday" && item.isApproved === "1"
    );

    if (!hasApprovedDay) {
      // lightweight user feedback and abort
      window.alert("Please approve at least one day before proceeding.");
      return;
    }
    const payload = {
      rid: selectedRowData && selectedRowData.rid,
      emp_id: selectedRowData && selectedRowData.emp_id,
      roleid: user && user.role,
      isapproved: "1",
      approvedBy: user && user.empid,
      approvedDays: isApprovedCount.toString(),
      isgoodwill: isGoodWillCount.toString(),
      isPartialApproved:
        isApprovedCount < selectedRowData.leavedays ? "1" : "0",
      isprobation: selectedRowData && selectedRowData.isProbation,
      actionComment: html,
      approvedDayslist: approvedDayslist
        .filter((item) => item.datetype === "Weekday")
        .map((item) => ({
          date: moment(item.lDate, "DD-MM-YYYY").format("YYYY-MM-DD"),
          ishaifDay: item.ishalfday,
          ispaid: item.ispaid,
          isGoodWill: item.isGoodWill,
          isApproved: item.isApproved,
        })),
    };

    // console.log(payload);

    LeaveHistoryService.empLeaveApproveProcess(payload)
      .then((resp) => {
        if (resp.data) {
          setSuccess(true);
          setHeading("Leave Request Approved Succesfully");
          fetchData();
          setApproveModal(false);
        }
      })
      .catch((e) => console.log(e));
  };

  return (
    <>
      <div
        className={`${
          approveModal ? "sortByModal visible" : "sortByModal hidden"
        }`}
      >
        <div className="flex">
          <div className="sort-list">
            <div className="heading mb-3">
              <span>Approve leave request</span>
            </div>

            <div className="leaveModalHeading">
              <div className="row">
                <div className="col-lg-6">
                  <div className="left-flex">
                    <div className="profile">
                      {leaveInfo && leaveInfo.profile ? (
                        <img src={profileImg} width={40} alt="profileImg" />
                      ) : (
                        <>
                          <div className="circle">
                            <span>{getNameInitials(leaveInfo && leaveInfo.name)}</span>
                          </div>
                        </>
                      )}
                      <div className="profile-info">
                        <span className="name">
                          {leaveInfo && leaveInfo.name}
                        </span>
                        <span className="desig">
                          {leaveInfo && leaveInfo.designation}
                        </span>
                      </div>
                    </div>
                    <div className="csort">
                      <div className="d-flex flex-column">
                        <label htmlFor="leaveType" className="form-label">
                          Duration - {selectedRowData.leavedays} Days
                        </label>
                        {user.role === "1" || user.role === "4" ? (
                          <label htmlFor="leaveType" className="form-label">
                            Approved Leave Days by RM -{" "}
                            {selectedRowData.approvedDays} Days
                          </label>
                        ) : null}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6">
                  {leaveInfo && leaveInfo.isprobationsts === "0" ? (
                    <>
                      {" "}
                      <div className="balance">
                        <div className="left">
                          <span>Balance</span>
                        </div>
                        <div className="right">
                          {/* <div className="flex">
                        <span>Monthly:</span>
                        <span className="count">01</span>
                      </div> */}
                          <div className="flex">
                            <span>Quarterly:</span>
                            <span className="count">
                              {leaveInfo.queterlyBalanceLeave}
                            </span>
                          </div>
                          <div className="flex">
                            <span>Yearly:</span>
                            <span className="count">
                              {leaveInfo.yearlyBalanceLeave}
                            </span>
                          </div>
                        </div>
                      </div>
                    </>
                  ) : null}
                </div>
              </div>
            </div>

            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Half Day</th>
                  {user.role === "1" || user.role === "4" ? (
                    <>
                      {leaveInfo && leaveInfo.isprobationsts === "0" && <th>Paid</th>}
                      <th>Goodwill</th>
                    </>
                  ) : null}
                  <th>Approved</th>
                </tr>
              </thead>
              <tbody>
                {Array.isArray(approvedDayslist)
                  ? approvedDayslist.map((item) => {
                      return (
                        <tr key={item.lDate}>
                          <th>{item.lDate.split(" ")[0]}</th>
                          {item.datetype === "Weekday" ? (
                            <>
                              <td>{item.ishalfday === "1" ? "Yes" : "No"}</td>
                              {user.role === "1" || user.role === "4" ? (
                                <>
                                  {leaveInfo && leaveInfo.isprobationsts === "0" && (
                                    <>
                                      <td>
                                        <input
                                          type="checkbox"
                                          onChange={(e) =>
                                            setIsPaid(e, item.lDate)
                                          }
                                          checked={item.ispaid === "1"}
                                        />
                                      </td>
                                    </>
                                  )}

                                  <td>
                                    <input
                                      type="checkbox"
                                      onChange={(e) =>
                                        setIsGoodwill(e, item.lDate)
                                      }
                                      checked={item.isGoodWill === "1"}
                                    />
                                  </td>
                                </>
                              ) : null}

                              <td>
                                <input
                                  type="checkbox"
                                  onChange={() => setIsApproved(item.lDate)}
                                  checked={item.isApproved === "1"}
                                />
                              </td>
                            </>
                          ) : item.datetype === "Holiday" ? (
                            <th colSpan={4} style={{ textAlign: "center" }}>
                              {item.datetype}
                            </th>
                          ) : item.datetype === "Weekend" ? (
                            <th colSpan={4} style={{ textAlign: "center" }}>
                              {item.datetype}
                            </th>
                          ) : null}
                        </tr>
                      );
                    })
                  : null}
              </tbody>
              <tfoot>
                <tr>
                  <th>Total</th>
                  <th></th>
                  {user.role === "1" || user.role === "4" ? (
                    <>
                      {leaveInfo && leaveInfo.isprobationsts === "0" && <th></th>}
                      <th>{isGoodWillCount}</th>
                    </>
                  ) : null}
                  <th>{isApprovedCount}</th>
                </tr>
              </tfoot>
            </table>

            <div className="mb-3">
              <label htmlFor="leaveType" className="form-label">
                Remark
              </label>
              <Editor value={html} onChange={onChange} />
            </div>
          </div>
          <div className="sort-action">
            <button className="btn btn-approve" onClick={approveLeaveRequest}>
              Approve
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default ApproveRequest;
